<template>
  <div class="middle-top">
    <div class="container">
      <div id="chart" style="width: 100%" :style="'height:' + height + 'px'"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  props: {
    sourceData: {
      default() {
        return []
      },
    },
  },
  watch: {
    sourceData: {
      deep: true,
      handler(val) {
        this.init()
      },
    },
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.getElementById('chart'))

    this.init()
  },
  methods: {
    init() {
      const xData = []
      const qualified = []
      const unqualified = []
      const markList = []

      this.sourceData.forEach((row, i) => {
        xData.push(row.label)
        qualified.push(row.合格人数 * 1)
        unqualified.push(row.参与人数 * 1 - row.合格人数 * 1)

        markList.push({
          name: row.label,
          value: Math.floor(row.rank * 100) + '%',
          xAxis: i,
          yAxis: row.参与人数 * 1 + 1,
        })
      })

      const label = {
        show: true,
      }

      this.myChart.setOption({
        legend: {
          show: true,
          type: 'plain',
          bottom: '2%',
          textStyle: {
            color: '#fff',
          },
        },
        xAxis: {
          data: xData,
          axisLabel: {
            show: true,
            interval: 0,
            color: '#fff',
          },
        },
        yAxis: {
          max: function(value) {
            return Math.floor((value.max + 10) / 10) * 10
          },
          axisLabel: {
            show: true,
            interval: 0,
            color: '#fff',
          },
        },
        series: [
          {
            name: '合格',
            type: 'bar',
            stack: 'total',
            label: label,
            data: qualified,
            itemStyle: {
              color: '#2084FF',
            },
            markPoint: {
              symbol: 'pin',
              data: markList,
            },
          },
          {
            name: '不合格',
            type: 'bar',
            stack: 'total',
            itemStyle: {
              color: '#F7B500',
            },
            label: label,
            data: unqualified,
          },
        ],
      })
    },
  },
  data() {
    return {
      myChart: {},
      data: [],
      labelInterval: [
        'value',
        {
          useHtml: true,
          htmlTemplate: function htmlTemplate(text, item) {
            var a = item.point
            console.log(a)
            a.percent = a.rank * 100 + '%'
            return '<span class="g2-label-item"><p class="g2-label-item-value">' + a.人数 + '</p></div>'
          },
        },
      ],
      height: 355 * (window.innerWidth / 1920),
      padding: [
        20 * (window.innerWidth / 1920),
        20 * (window.innerWidth / 1920),
        110 * (window.innerWidth / 1920),
        40 * (window.innerWidth / 1920),
      ],
      label: {
        textStyle: {
          fill: '#82A9EF',
        },
      },
    }
  },
}
</script>
